module.exports = "<section class=\"changelog changelog-page\">\n    <div ui-view></div>\n</section>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/changelog/views/index.html
 ** module id = 443
 ** module chunks = 0
 **/